import { useEffect, useState, useContext } from "react";
import * as rewardsApi from "../services/ApiServices/ApiService";
import { UserContext } from "../context/userContext";
import { useNavigate } from "react-router-dom";
import { logTrace } from "../services/ApiServices/LoggingService";

const AccessDenied = () => {
  const [gatewayUrl, setGatewayUrl] = useState(null);
  const user = useContext(UserContext);
  const navigate = useNavigate();

  const getFederatedLoginUrl = () => {
    const handleError = (error) => {
      logTrace(
        error,
        "error when calling rewardsApi.getExternalUrls",
        "getFederatedLoginUrl in AccessDenied.jsx"
      );
    };
    const handleSuccess = (response) => {
      setGatewayUrl(response.gatewayUrl);
    };

    rewardsApi.getExternalUrls(handleSuccess, handleError);
  };

  useEffect(() => {
    getFederatedLoginUrl();

    if (user) {
      if (
        user.role === "IA Principal" &&
        user.enrollmentStatus.participationIndicator
      ) {
        navigate("/home");
      }
    }
  }, []);

  return (
      <div className="container">
        <form>
          <div className="row">
            <div className="hidden-sm col-md-4">
              <img src="/images/geckoPose.png" alt="Gecko" />
            </div>
            <div className="col-sm-12 col-md-8">
              <div className="encounter-error-message">
                <div className="section-header">
                  <div className="section-header-title-subtext">
                    <h3 className="font--bold">Access Not Allowed</h3>
                    <br />
                    <p>
                      <span>
                        You are not authorized to access this part of the site.
                        Talk to your principal to get access.
                      </span>
                    </p>
                    <br />
                    <p>
                      <a
                        className="btn btn--primary"
                        href={gatewayUrl}
                        rel="noreferrer"
                        data-trackid="return-to-gateway"
                      >
                        Return to GEICO Gateway
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
  );
};
export default AccessDenied;
